import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

type MenuSheetItemProps = {
  title: string;
  onClick: () => void;
  disabled?: boolean | undefined;
};

function MenuSheetItem({
  title,
  onClick,
  disabled = false,
}: MenuSheetItemProps) {
  return (
    <FixaListViewItem
      type="button"
      title={title}
      onClick={onClick}
      control="navigational"
      controlIcon={null}
      disabled={disabled}
    />
  );
}

export default MenuSheetItem;
